import { render } from "./SurveyFinish.vue?vue&type=template&id=12c0bd50&scoped=true"
import script from "./SurveyFinish.vue?vue&type=script&lang=js"
export * from "./SurveyFinish.vue?vue&type=script&lang=js"

import "./SurveyFinish.vue?vue&type=style&index=0&id=12c0bd50&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c0bd50"]])

export default __exports__